"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleOnlineTag = void 0;
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/vehicle/enums");
let VehicleOnlineTag = class VehicleOnlineTag {
    constructor() {
        /** true: online, active | false: online, deactivated | null: not online */
        this.onlineState = null;
        this.previousVehicle = '';
        this.setOnlineState = () => {
            var _a;
            this.onlineState = null;
            if ((_a = this.vehicle.apiData) === null || _a === void 0 ? void 0 : _a.MOBILE_SELLER) {
                this.onlineState = true;
                if (this.vehicle.vehicleData.availability.code !== enums_1.EAvailabilityCode.Available) {
                    this.onlineState = false;
                    return;
                }
                if (this.vehicle.apiData.MOBILE_SELLER.adMeta.deactivated) {
                    this.onlineState = false;
                }
            }
        };
    }
    ngOnChanges() {
        if (String(this.vehicle._id) === this.previousVehicle)
            return;
        this.previousVehicle = String(this.vehicle._id);
        this.setOnlineState();
    }
    ngOnInit() {
        this.previousVehicle = String(this.vehicle._id);
        this.setOnlineState();
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleOnlineTag.prototype, "vehicle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], VehicleOnlineTag.prototype, "short", void 0);
VehicleOnlineTag = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-online-tag',
        template: `
    <tag
      *ngIf="onlineState !== null"
      [color]="onlineState ? 'blue' : 'orange'"
    >
      <ng-template [ngIf]="onlineState">
        <span>
          {{ !short ? 'mobile.de' : '' }}
          <i class="fa-solid fa-earth-americas"></i>
        </span>
      </ng-template>

      <ng-template [ngIf]="!onlineState">
        <span>
          {{ !short ? 'mobile.de (deaktiviert)' : '' }}
          <i class="fa-solid fa-circle-pause"></i>
        </span>
      </ng-template>
    </tag>
  `,
    })
], VehicleOnlineTag);
exports.VehicleOnlineTag = VehicleOnlineTag;
